import { ReactNode } from 'react';

type PageContainerProps = {
    children: ReactNode | ReactNode[];
};

function PageContainer({ children }: PageContainerProps): JSX.Element {
    return <div className="w-[90%] max-w-[var(--max-width)] m-auto pt-6">{children}</div>;
}

export default PageContainer;
